var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6666 7.99974C14.6666 11.6817 11.6815 14.6668 7.9995 14.6668C4.31921 14.6627 1.33659 11.68 1.33325 7.99974C1.33325 4.31862 4.31754 1.3335 7.9995 1.3335C11.6815 1.3335 14.6666 4.31862 14.6666 7.99974ZM2.44402 7.99974C2.44402 11.0683 4.93092 13.5561 7.9995 13.5561C11.0664 13.5527 13.5517 11.0667 13.555 7.99974C13.555 4.932 11.0681 2.44426 7.9995 2.44426C4.93092 2.44426 2.44402 4.932 2.44402 7.99974ZM6.71929 8.93196L7.79667 10.0093C8.06789 10.2806 8.06789 10.7204 7.79667 10.9908C7.52545 11.262 7.08565 11.262 6.81526 10.9908L4.315 8.49133C4.18481 8.36114 4.11139 8.18422 4.11139 7.99979C4.11139 7.81619 4.18481 7.63927 4.315 7.50908L6.81526 5.00966C7.08565 4.73844 7.52545 4.73844 7.79667 5.00966C8.06789 5.28005 8.06789 5.71985 7.79667 5.99107L6.71929 7.06845C6.68007 7.10851 6.66838 7.16776 6.69008 7.2195C6.71094 7.27124 6.76185 7.30546 6.81776 7.30546H11.1949C11.5779 7.30546 11.8892 7.61674 11.8892 7.99979C11.8892 8.38367 11.5779 8.69412 11.1949 8.69412H6.81776C6.76185 8.69412 6.71011 8.72834 6.68925 8.78008C6.66755 8.83182 6.67923 8.89191 6.71929 8.93196Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCircle);
export default __webpack_public_path__ + "static/media/LeftCircle.4110cb33da843f5f82f7e3ebd38a099d.svg";
export { ForwardRef as ReactComponent };